// LIBRARY IMPORTS
import React, { FC } from 'react';
import { Grid, Typography, Button, makeStyles } from "@material-ui/core";
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Alert } from '@material-ui/lab';


// LOCAL IMPORTS
import { IFilterData } from 'gateways/recibo.interfaces';
import { esConceptoVivienda } from 'utils/concepto.vivienda';
import { IFilterOption } from 'utils/interfaces';
import ConceptoIcon from '../../../components/concepto.icon';
import TextNumber from '../../../components/text-number';
import Term from '../../../components/term';

// STYLES
import styles from '../../shared/tributos.grid.styles';
import { IReciboFlexible } from 'gateways/recibo-flexibles.interfaces ';


type InheritsProps = RouteComponentProps;
interface IProps extends InheritsProps {
    recibo: IReciboFlexible;
    filterData: IFilterData | null;
    moreInfo: (recibo: IReciboFlexible) => void;
    onPay: (recibo: IReciboFlexible) => void;
}

const useStyles = makeStyles(styles);

const ReciboGrid: FC<IProps> = (props) => {
    const {
        recibo,
        filterData,
        moreInfo,
        onPay,
    } = props;

    // HOOKS
    const classes = useStyles();

    // CONSTANTS
    const organismo = filterData && filterData.organismos ? filterData.organismos.find((x: IFilterOption<string>) => x.value === recibo.organismo.codigo) : null;

    // HANDLERS



    const handleMoreInfo = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        moreInfo(recibo);
    };

    const handleImporte = () => {
        let importe = recibo.importeFlexibleAcumulado;
        return importe;
    }


    return (
        <Grid container className={classes.root}>
            <Grid item className={classes.imageGrid}>
                {
                    <div className={classes.imagenContainer}>
                        <ConceptoIcon concepto={recibo.concepto.idTipo} codigo={recibo.concepto.codigo} />
                    </div>
                }
            </Grid>
            <Grid item className={classes.grow}>
                <Grid container className={classes.contentRoot}>
                    <Grid className={[classes.grow, classes.width0].join(' ')}>
                        <Typography className={classes.highlightText}>
                            {organismo ? organismo.label : recibo.organismo.nombre}
                        </Typography>
                        <Typography className={classes.highlightText}>
                            <Term component="CarteroVirtual" text={recibo.concepto.nombre} />
                        </Typography>
                        <Typography className={classes.detailText}>
                            {
                                esConceptoVivienda(recibo.concepto.idTipo) ? recibo.direccionTributaria : recibo.objeto
                            }
                        </Typography>
                    </Grid>
                    <Grid>
                        <div>
                            <Typography component="span" className={[classes.price, classes.priceLabel].join(' ')}>
                                {
                                    <Term component="CarteroVirtual" text="Pago_flexible_importe" />
                                }
                            </Typography>
                            <TextNumber
                                component="span"
                                className={[classes.price, classes.priceLabel].join(' ')}
                                value={recibo.importeRecibo}
                                options={{ isMoney: true, minDecimalLength: 2, maxDecimalLength: 2 }} />
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                            <Typography component="span" className={[classes.priceNoWeight, classes.priceLabel].join(' ')}>
                                {
                                    <Term component="CarteroVirtual" text="Importe pagado" />
                                }
                            </Typography>
                            <TextNumber
                                component="span"
                                className={[classes.priceNoWeight, classes.priceLabel].join(' ')}
                                value={handleImporte()}
                                options={{ isMoney: true, minDecimalLength: 2, maxDecimalLength: 2 }} />
                        </div>

                    </Grid>
                </Grid>

                {
                    // recibo.fechaInicio && recibo.fechaFin && recibo.fechaFin > recibo.fechaInicio
                    //     ? <Typography className={classes.detailText}>del {moment(recibo.fechaInicio).format('DD/MM/YYYY')} al {moment(recibo.fechaFin).format('DD/MM/YYYY')}</Typography>
                    //     : ''
                }


                {/* ETIQUETA */}

                {/* {
                    recibo.estadoEtiqueta &&
                    <Typography className={[classes.etiquetaText].join(' ')}>
                        <Term component="Global" text={recibo.estadoEtiqueta} />
                    </Typography>

                } */}

                <div className={classes.bannerBtn}>
                    {recibo.importeRecibo - recibo.importeFlexibleAcumulado >= 1000000 ?
                        <Alert severity="info"><Term component="CarteroVirtual" text="ContactarAtib" /></Alert>
                        : ''
                    }
                    <Button variant="contained" color="default" size="small" className={classes.btnMoreInfo} onClick={handleMoreInfo}>
                        <Term component="CarteroVirtual" text="+ INFO" />
                    </Button>
                    { recibo.importeFlexibleAcumulado != recibo.importeRecibo ?
                        <Button
                            variant="contained" color="primary" size="small" className={classes.btnAddPay}
                            onClick={(event) => {
                                event.stopPropagation();
                                onPay(recibo);
                            }}
                            disabled={false}
                        >
                            {"Pagar"}
                        </Button>
                        : ''
                    }

                </div>
            </Grid>
        </Grid>
    );
}

export default withRouter(ReciboGrid);